import React from "react";
import "./Loader.css";

const CricketBallLoader = () => (
  <div className="parent-container">
    <div className="loader">
    </div>
  </div>
);

export default CricketBallLoader;
